import { useTheme } from 'styled-components'

import {
  type LinearLoaderVariant,
  LinearLoaderStyled,
} from './styles/LinearLoaderStyled'

export interface ILinearLoaderProps {
  /** Visual treatment. `shimmer` (default) is the colored progress bar; `skeleton` is the neutral content placeholder. */
  variant?: LinearLoaderVariant
  /** Base color for the shimmer gradient. Defaults to `theme.colors.badge.inProgress.background`. `shimmer` only. */
  color?: string
  /** Bar width. Numbers are treated as px; strings (e.g. `'100%'`) pass through. Default: `'100%'`. */
  width?: string | number
  /** Bar height in px. Default: 12. */
  height?: number
  /** Bar border-radius in px. Default: 8. */
  borderRadius?: number
  /** Renders the skeleton gradient on a dark background. `skeleton` only. Default: false. */
  inverted?: boolean
  /** Accessible label, forwarded as `aria-label` for the `skeleton` variant. */
  ariaLabel?: string
}

export const LinearLoader = ({
  variant = 'shimmer',
  color,
  width = '100%',
  height = 12,
  borderRadius = 8,
  inverted = false,
  ariaLabel,
}: ILinearLoaderProps) => {
  const theme = useTheme()

  const a11yProps =
    variant === 'skeleton'
      ? { role: 'img', 'aria-label': ariaLabel ?? 'Loading interface...' }
      : {}

  return (
    <LinearLoaderStyled
      {...a11yProps}
      variant={variant}
      color={color ?? theme.colors.badge.inProgress.background}
      width={width}
      height={height}
      borderRadius={borderRadius}
      inverted={inverted}
    />
  )
}
